<template>
    <p>Logout</p>
</template>

<script>

export default {
    name: 'Logout',
    created () {
        var self = this
        this.$toastr ('success', 'Logged out','Success')
        this.$store.dispatch ("logout", {self: self}).then (r => {
            console.log ("LOGOUT ib BACKEND")
            window.location.href = window.location.origin + "/account/logout/"
        })
    }
}
</script>
